module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJ0dXJiby1pY29uLWZvbnQtZTQxOTdmZmM2Mi5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./~/turbo-style-common/lib/fonts/turbo-icon-font.svg
// module id = 15
// module chunks = 8